import { useMutation } from "@tanstack/react-query";
import { apiFetch } from "./client";

// Register / forgot / reset endpoints are unauthenticated. apiFetch
// still works — it just skips the Authorization header when no token
// is set in memory. We co-locate the three mutations here so pages
// don't each invent their own fetch plumbing.

export interface RegisterRequest {
  companyName: string;
  contactEmail: string;
  firstName: string;
  lastName: string;
  password: string;
}

export interface RegisterResponse {
  tenantId: string;
  userId: string;
  message: string;
}

export function useRegister() {
  return useMutation({
    mutationFn: (body: RegisterRequest) =>
      apiFetch<RegisterResponse>("/auth/register", {
        method: "POST",
        body: JSON.stringify(body),
      }),
  });
}

export interface ForgotPasswordRequest {
  email: string;
}

export function useForgotPassword() {
  return useMutation({
    mutationFn: (body: ForgotPasswordRequest) =>
      apiFetch<{ message: string }>("/auth/forgot-password", {
        method: "POST",
        body: JSON.stringify(body),
      }),
  });
}

export interface ResetPasswordRequest {
  email: string;
  code: string;
  newPassword: string;
}

export function useResetPassword() {
  return useMutation({
    mutationFn: (body: ResetPasswordRequest) =>
      apiFetch<{ message: string }>("/auth/reset-password", {
        method: "POST",
        body: JSON.stringify(body),
      }),
  });
}
